/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-10-30 11:13:45
 */
import React, { useEffect, useRef, useState } from 'react'
import { Button, Card } from 'antd'
import FileSaver from 'file-saver'
import fetch from 'isomorphic-fetch'
import { debounce } from '../../../utils/utils'
import { LoadingOutlined } from '@ant-design/icons'

export default ({ fileName, exportURL }) => {
  const [isFileReady, setIsFileReady] = useState(false)
  const timerRef = useRef<any>()

  const fetchFile = () => {
    fetch(exportURL, {
      method: 'HEAD'
    }).then((res) => {
      if (res.status === 200) {
        setIsFileReady(true)

        clearTimeout(timerRef.current)
      } else {
        timerRef.current = setTimeout(fetchFile, 2000)
      }
    })
  }

  useEffect(() => {
    fetchFile()

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  const handleDownload = debounce(
    () => FileSaver.saveAs(exportURL, fileName),
    1000
  )

  // const handleDownload = () => {
  //   const a = document.createElement('a')
  //   a.href = exportURL
  //   a.download = fileName
  //   a.click()
  // }

  return (
    <div className="download-history-item">
      <Card
        size="small"
        title={fileName}
        headStyle={{
          background: '#ececec'
        }}
      >
        {isFileReady ? (
          <Button type="primary" onClick={handleDownload}>
            立即下载
          </Button>
        ) : (
          <div className="prepare">
            <LoadingOutlined
              style={{
                marginRight: 4
              }}
            />
            正在准备文件...
          </div>
        )}
      </Card>
    </div>
  )
}
